import * as z from "zod";

export const getCatalogVendors = {
  name: "getCatalogVendors" as const,
  input: z.object({ search: z.string().optional() }),
  output: z.object({ vendors: z.array(z.string()) }),
};
